import { createListenerMiddleware } from '@reduxjs/toolkit';
import { NotificationTypeEnum } from 'Components/designSystem';
import i18n from 'i18next';
import { showToast, ToastOptions } from 'modules/ToastManager';
import { getOfferKey } from 'pages/candidateOffer/helpers';

import { addProcessedOffer } from './candidateOfferListSlice';

const offerReplyMiddleware = createListenerMiddleware();

const SUCCESS_NOTIFICATION_DURATION = 5000;

offerReplyMiddleware.startListening({
    actionCreator: addProcessedOffer,
    effect: async (action, listenerAPI) => {
        const { processedOffer } = action.payload;
        const { orderId, orderRoleId } = processedOffer;

        const toast: ToastOptions = {
            id: getOfferKey(orderId, orderRoleId),
            type: NotificationTypeEnum.Success,
            description: i18n.t('successToastText', { ns: 'candidateOffers' }),
            duration: SUCCESS_NOTIFICATION_DURATION
        };

        listenerAPI.dispatch(showToast({ toast }));
    }
});

export default offerReplyMiddleware;
